export const Speed = [
  {
    id: 1,
    speed: "0.25x",
    value: 2000,
  },
  {
    id: 2,
    speed: "0.5x",
    value: 1500,
  },
  {
    id: 3,
    speed: "1x",
    value: 1000,
  },
  {
    id: 4,
    speed: "2x",
    value: 500,
  },
  {
    id: 5,
    speed: "4x",
    value: 250,
  },
];
